import { ExportVideoInstance } from "./ExportVideoInstance.js";
class ExportVideoPlugin {
    constructor(engine) {
        this.id = "export-video";
        this._engine = engine;
    }
    getPlugin(container) {
        return new ExportVideoInstance(container, this._engine);
    }
    loadOptions() {
    }
    needsPlugin() {
        return true;
    }
}
export async function loadExportVideoPlugin(engine, refresh = true) {
    await engine.addPlugin(new ExportVideoPlugin(engine), refresh);
}
